<template>
  <footer class="">
    <div class="container-md d-flex align-items-center justify-content-between stihl-footer">

      <div class="d-flex footer-links">
      <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.imprint_url)">
          {{ $t('dss.footer.imprint') }}</a>
      </span>
        <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.terms_url)">
          {{ $t('dss.footer.terms') }}</a>
      </span>
        <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.privacy_url)">
          {{ $t('dss.footer.privacy') }}</a>
      </span>
      </div>

      <div class="footer-address">
        <span class="address">{{ $t('dss.footer.legalEntity') }}</span>
        <div class="version">{{ version }}</div>
      </div>

    </div>
  </footer>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { localizedLink } from '@/lang';

export default defineComponent({
  name: 'StihlFooter',
  data() {
    return {
      config: window.APP_CONFIG,
      version: import.meta.env.VITE_APP_VERSION,
    };
  },
  methods: {
    /*localizedLink(links: Record<string, string>) {
      return links[this.$i18n.locale] ?? links.en;
    },*/
    localizedLink
  },
});
</script>

<style scoped>
.version {
  position: relative;
  float: right;
  padding: 0 1em;
  color: var(--grey-base);
}
</style>
